export const environment = {
   production: false,
   api_url: 'https://api.masterloop.citybike.cloud/',
   app_name: 'Masterloop Citybike Cloud',
   api_version: '5',
   live_port: '10443',
   live_connection_secured: true
};
